/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { Box, Typography, Dialog } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import AppButton from 'Shared/UI/Button';
import { SingleDatePicker } from 'Shared/UI/DateRangePicker';
import DropdownSelect from 'Shared/UI/DropdownSelect';
import useNetworkLoader from 'hooks/useNetworkLoader';
import { exporterFactures } from './FacturesServices';

const TYPE_OPTIONS = [
  { value: 'all', label: 'Toutes les factures (réglées et non réglées)' },
  { value: 'non-reglee', label: 'Factures non réglées uniquement' },
  { value: 'reglee', label: 'Factures réglées uniquement' },
];

const TYPE_OPTIONS_MF = [
  { value: 'all', label: 'Tous les devis (validés et non validés)' },
  { value: 'non-reglee', label: 'Devis non validés uniquement' },
  { value: 'reglee', label: 'Devis validés uniquement' },
];

const ExportFacturesModal = ({ open, onClose, isMF = false }) => {
  const { callApi } = useNetworkLoader();
  const [types, setTypes] = useState(null);
  const [dateDebut, setDateDebut] = useState(null);
  const [dateFin, setDateFin] = useState(null);
  const [exporting, setExporting] = useState(false);

  useEffect(() => {
    if (open) {
      setTypes(null);
      setDateDebut(null);
      setDateFin(null);
    }
  }, [open]);

  const canExport = types && dateDebut && dateFin;

  const handleExport = async () => {
    if (!canExport) return;
    setExporting(true);
    const formatISO = (d) => `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
    await callApi(
      () => exporterFactures({
        type: types,
        startDate: formatISO(dateDebut),
        endDate: formatISO(dateFin),
        officiel: false,
      }),
      (response) => {
        const disposition = response?.headers?.['content-disposition'] || '';
        const filename = disposition.split('filename=')[1] || `EXPORT_${new Date().toISOString().slice(0,10)}.pdf`;
        const url = window.URL.createObjectURL(response?.data);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        onClose();
      },
      false,
    );
    setExporting(false);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      disableScrollLock
      sx={{
        '& .MuiDialog-container': {
          alignItems: 'flex-start',
          justifyContent: 'center',
        },
        '& .MuiDialog-paper': {
          margin: 0,
          position: 'fixed',
          top: '210px',
          left: '50%',
          transform: 'translateX(-50%)',
        },
      }}
      PaperProps={{
        sx: {
          borderRadius: '8px',
          p: '16px',
          pb: '24px',
          px: '24px',
          width: '485px',
          maxWidth: '100vw',
          boxShadow: '0px 8px 32px rgba(0,0,0,0.12)',
          border: '1px solid #D1D5DB',
          backgroundColor: '#FFFFFF',
          overflow: 'visible',
          opacity: 1,
        },
      }}
    >
      {/** Title */}
      <Typography sx={{ fontSize: '20px', fontWeight: 700, color: '#385576', mb: '16px' }}>
        {isMF ? 'Exporter les devis' : 'Exporter les factures'}
      </Typography>

      {/** Type dropdown */}
      <Box sx={{ mb: '16px' }}>
        <DropdownSelect
          options={isMF ? TYPE_OPTIONS_MF : TYPE_OPTIONS}
          value={types}
          onChange={setTypes}
          placeholder="Type"
          width="100%"
        />
      </Box>

      {/** Date row */}
      <Box sx={{ display: 'flex', gap: '12px', mb: '16px' }}>
        <SingleDatePicker
          value={dateDebut}
          onApply={(date) => setDateDebut(date)}
          placeholder="Date début"
        />
        <SingleDatePicker
          value={dateFin}
          onApply={(date) => setDateFin(date)}
          placeholder="Date fin"
        />
      </Box>

      {/** Buttons */}
      <Box sx={{ display: 'flex', gap: '12px' }}>
        <AppButton
          variant="custom"
          label="Annuler"
          icon={<CloseIcon />}
          color="#FFFFFF"
          hoverColor="#F1F5F9"
          textColor="#385576"
          onClick={onClose}
          sx={{ flex: 1, border: '1px solid #E2E8F0' }}
        />
        <AppButton
          variant="custom"
          label="Exporter"
          icon={<FileDownloadOutlinedIcon />}
          color={canExport ? '#007BC6' : '#E2E8F0'}
          hoverColor={canExport ? '#005F9E' : '#E2E8F0'}
          textColor={canExport ? '#FFFFFF' : '#A0AEC0'}
          onClick={canExport ? handleExport : undefined}
          loading={exporting}
          sx={{ flex: 1, cursor: canExport ? 'pointer' : 'not-allowed' }}
        />
      </Box>
    </Dialog>
  );
};

export default ExportFacturesModal;
